import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";

import { HashRouter } from "react-router-dom";
import "./assets/base.scss";
import Main from "./DemoPages/Main";
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";

const store = configureStore();
const rootElement = document.getElementById("root");

// Ignore noisy browser ResizeObserver warnings that are not app-breaking.
const isResizeObserverNoise = (message = "") =>
  typeof message === "string" &&
  (message.includes("ResizeObserver loop completed with undelivered notifications") ||
    message.includes("ResizeObserver loop limit exceeded"));

window.addEventListener(
  "error",
  (event) => {
    const message = event?.message || event?.error?.message || "";
    if (!isResizeObserverNoise(message)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reasonMessage =
      event?.reason?.message ||
      (typeof event?.reason === "string" ? event.reason : "");
    if (!isResizeObserverNoise(reasonMessage)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

const renderApp = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <Component />
      </HashRouter>
    </Provider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept("./DemoPages/Main", () => {
    const NextApp = require("./DemoPages/Main").default;
    renderApp(NextApp);
  });
}
serviceWorker.unregister();
